import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import AdditionalTerms from './AdditionalTerms';
import { hot } from 'react-hot-loader';

function StaticBody({ loanObject = {} }) {
	return (
		<>
			<p className="justify">
				<Trans i18nKey="loan_agreement.static_body_advance_pay">
					<strong>ADVANCE PAYMENT.</strong>
					The BORROWER can repay the Loan in advance. The PARTIES can agree to lower the interest because of
					advance payments.
				</Trans>
			</p>

			<p className="page-break"></p>

			<Trans i18nKey="loan_agreement.static_body_default">
				<p className="justify">
					<strong>DEFAULT.</strong>
					If the BORROWER does not pay on time according to the agreed manner of payment above, the LENDER
					may:
				</p>
				<p className="justify">
					(a) ACCELERATE: Demand payment of the full amount of the Loan and interest immediately.
				</p>
				<p>AND</p>
				<p className="justify">(b) GUARANTEE: Demand payment from the GUARANTOR.</p>
			</Trans>

			<AdditionalTerms loanObject={loanObject} />

			<p className="justify">
				<Trans i18nKey="loan_agreement.static_body_termination_new">
					<strong>TERMINATION.</strong>
					{/* This Agreement shall end only when the LENDER has been paid the Loan and the interest in full.
					Partial payments by the BORROWER or the GUARANTOR to the LENDER will not terminate this Agreement. */}
					This Agreement shall end only when the LENDER has been paid the Loan and the interest in full and/or
					the LENDER has forgiven the full/remaining balance of the Loan.
				</Trans>
			</p>

			<p className="justify">
				<Trans i18nKey="loan_agreement.static_body_attorney_fee">
					<strong>ATTORNEY’S FEES.</strong>
					If the LENDER needs the services of a lawyer to collect payment for any unpaid amount that is due
					and payable, the LENDER is entitled to also collect attorney’s fees equal to at least TWENTY-FIVE
					PERCENT (25%) of the total amount due plus all other expenses incurred by the LENDER to collect
					payment, which the BORROWER hereby promises to pay.
				</Trans>
			</p>

			<p className="justify">
				<Trans i18nKey="loan_agreement.static_body_remedies">
					<strong>REMEDIES.</strong>
					The LENDER may pursue all available remedies simultaneously.
				</Trans>
			</p>

			<p className="justify">
				<Trans i18nKey="loan_agreement.static_body_successors">
					<strong>SUCCESSORS.</strong>
					If the BORROWER dies or is incapacitated, the Loan and all interest shall be immediately due and
					payable, and shall be paid by the BORROWER’S executor, administrator, successors, heirs and/or
					assigns. The BORROWER cannot assign, delegate, or otherwise transfer any of its rights or
					obligations under this Agreement to anybody else unless the LENDER agrees to it first.
				</Trans>
			</p>

			<p className="justify">
				<Trans i18nKey="loan_agreement.static_body_entire">
					<strong>ENTIRE AGREEMENT.</strong>
					All the agreed terms and conditions between the BORROWER and the LENDER about the Loan are in this
					Agreement. However, if there is a GUARANTOR, some of the terms and conditions in the Contract of
					Guaranty (Annex “A”) and the Accession Agreement (Annex “B”) may apply to, and affect, the BORROWER
					and/or the LENDER. If the PARTIES want to make changes to this Agreement, they must write down those
					changes and sign that document. Immediately after both PARTIES have signed that document, the agreed
					changes automatically change, and become part of, this Agreement.
				</Trans>
			</p>

			<p className="justify">
				<Trans i18nKey="loan_agreement.static_body_governing_law">
					<strong>GOVERNING LAW.</strong>
					Philippine law governs this Agreement.
				</Trans>
			</p>

			<p className="justify">
				<Trans i18nKey="loan_agreement.static_body_venue">
					<strong>VENUE.</strong>
					The PARTIES agree that if there is a problem or disagreement about this Agreement, they will try
					their best to discuss the problem and work together to fix it. But if they cannot fix the problem
					and the BORROWER and/or the LENDER must go to court, they can only file a case with the courts that
					has jurisdiction over the place where the LENDER lives. They cannot go to any other court.
				</Trans>
			</p>
		</>
	);
}

export default hot(module)(withTranslation()(StaticBody));
